export const language: any = {
  title: 'Nguyên liệu',
  select_all: 'Chọn tất cả',
  deselect_all: 'Bỏ chọn tất cả',
  add: 'Thêm nguyên liệu',
  add_title: 'Vui lòng chọn cách thêm nguyên liệu',
  add_by_list: 'Thêm trực tiếp',
  add_total: 'Thêm tổng cộng {number} nguyên liệu',
  selecting: 'Tổng nguyên liệu',
  filter_title: 'Chọn sắp xếp',
  filter_newest: 'Thứ tự mới',
  filter_oldest: 'Thứ tự cũ',
  filter_alphabet: 'Thứ tự chữ cái',
  get_recipe: 'Nhận đề xuất món ăn AI',
  search_placeholder: 'Vui lòng nhập từ khoá tìm kiếm.',
  nodata: 'Không có nguyên liệu.',
  request: 'Thêm nguyên liệu',
  recipe_title: 'Món ăn đề xuất',
  option: {
    title: 'Chọn tùy chọn',
    desc: 'Chọn tùy chọn không phải là hạng mục bắt buộc',
    complete: 'Hoàn thành',
    reset: 'Cài lại',
  },
  msg: {
    msg_7: "Bạn có muốn thêm nguyên liệu đã chọn không ?",
    msg_8: `
      <p>Bạn có muốn thêm nguyên liệu đã chọn không ?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> đã có trong nguyên liệu hiện tại rồi nên được loại trừ.)</p>
    `,
    msg_9: "Bạn có muốn thêm nguyên liệu đã chọn vào giỏ hàng không ?",
    msg_10: `
      <p>Bạn có muốn thêm nguyên liệu đã chọn vào giỏ hàng không ?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> đã có trong nguyên liệu hiện tại rồi nên được loại trừ.)</p>
    `,
    confirm: 'Thêm nguyên liệu',
    cancel: 'Hủy',
    not_ingredient: 'Dường như nội dung mà bạn nhập vào không phải là nguyên liệu nấu ăn.<br />Vui lòng kiểm tra lại',
    ai_failed: 'Đã có lỗi xảy ra khi nhập nguyên liệu,<br />vui lòng thử lại sau',
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> bị loại trừ do đã có ở nguyên liệu hiện tại.)`
  },
  history: 'Lịch sử phân tích ảnh',
  myIngredient: "Nguyên liệu của tôi",
  history_no_data: "Chưa có lịch sử nào",
  history_take_photo: "Chụp hoặc chọn ảnh",
}
